export default __webpack_public_path__ + "static/media/akriti.af513c00.jpg";